import { render, staticRenderFns } from "./CookingCommentHistoryIndex.vue?vue&type=template&id=c016617e&"
import script from "./CookingCommentHistoryIndex.vue?vue&type=script&lang=js&"
export * from "./CookingCommentHistoryIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports